// extracted by mini-css-extract-plugin
module.exports = {"schoolPagesList":"styles-module--schoolPagesList--3wZXP","heading":"styles-module--heading--3mrPw","linksWrapper":"styles-module--linksWrapper--3s3zo"};